import {Component, ChangeDetectionStrategy} from '@angular/core';
import {Dialog} from '../../../../../interfaces/dialog/dialog';
import {DialogParams} from '../../../../../interfaces/dialog/dialog-params';
import { NgOptimizedImage } from '@angular/common';
import {ParisDatePipe} from '../../../../../pipes/date/paris-date.pipe';
import {Conversion} from '../../../../../models/conversion';
import {CurrencyPipe} from '../../../../../pipes/currency/currency.pipe';
import {CountryService} from '../../../../../services/country/country.service';
import {ConversionService} from '../../../../../services/conversion/conversion.service';
import {LoaderService} from '../../../../../services/loader/loader.service';
import {PercentPipe} from '../../../../../pipes/percent/percent.pipe';

@Component({
  selector: 'app-conversion-detail',
  imports: [
    ParisDatePipe,
    CurrencyPipe,
    NgOptimizedImage,
    PercentPipe
],
  templateUrl: './conversion-detail.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './conversion-detail.component.scss'
})
export class ConversionDetailComponent implements Dialog {
  conversion: Conversion | null = null;

  constructor(
    private loader: LoaderService,
    private conversionService: ConversionService,
    protected countryService: CountryService
  ) {
  }

  onDialogInit(params: DialogParams): void {
    params.visible = false;
    this.loader.startLoading();
    this.conversionService.findOneById(params.data.id, {
      groups: 'landingPage,product,offer,partner,accountManager,customPayout'
    }).subscribe(conversion => {
      this.conversion = conversion;
      this.loader.stopLoading();
      params.visible = true;
    });
  }
}
